import { h, render } from "preact";
import Tooltip from "../components/Tooltip.jsx";

export default function initTooltips() {
  setTimeout(() => {
    let nextId = 1;
    document.querySelectorAll("[data-tooltip]").forEach((element) => {
      const text = element.getAttribute("data-tooltip");
      const id = nextId++;
      element.setAttribute("data-tooltip-id", `tooltip-${id}`);

      const container = document.createElement("span");
      element.after(container);
      render(
        <Tooltip className="nioomi-tooltip" id={`tooltip-${id}`} place="bottom">
          {text}
        </Tooltip>,
        container
      );
    });
  }, 50);
}
